import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DivineServiceState } from '../models/divine-service-state.model';
import { DivineServiceValidationService } from './index';

/**
 * Servicio centralizado para crear y gestionar el formulario reactivo
 * de Servicios Divinos. Consolidar la lógica de creación de formularios
 * en un único lugar para facilitar mantenimiento y testing.
 */
@Injectable({
  providedIn: 'root'
})
export class DivineServiceFormBuilderService {

  constructor(
    private fb: FormBuilder,
    private validationService: DivineServiceValidationService
  ) {}

  /**
   * Crea un nuevo FormGroup para un Servicio Divino
   * con todos los campos y validadores necesarios
   */
  createServiceForm(): FormGroup {
    return this.fb.group({
      date: ['', Validators.required],
      type: ['', Validators.required],
      bibleText: ['', Validators.required],
      memberInCharge: [''],
      location: [''],
      organizationUnitId: ['', [Validators.required, this.validationService.getGuidValidator()]],
      totalMinors: [0, [Validators.required, Validators.min(0)]],
      totalAdults: [0, [Validators.required, Validators.min(0)]],
      notes: [''],
      offeringsARS: [null, [Validators.min(0)]],
      offeringsUSD: [null, [Validators.min(0)]],
      visitsAdults: [0, [Validators.min(0)]],
      visitsMinors: [0, [Validators.min(0)]],
      newAdults: [0, [Validators.min(0)]],
      newMinors: [0, [Validators.min(0)]]
    });
  }

  /**
   * Llena un formulario existente con datos de un estado
   */
  populateForm(form: FormGroup, state: DivineServiceState): void {
    form.patchValue({
      date: state.date,
      type: state.type,
      bibleText: state.bibleText,
      memberInCharge: state.memberInCharge,
      location: state.location,
      organizationUnitId: state.organizationUnitId,
      totalMinors: state.totalMinors,
      totalAdults: state.totalAdults,
      notes: state.notes,
      offeringsARS: state.offeringsARS,
      offeringsUSD: state.offeringsUSD,
      visitsAdults: state.visitsAdults,
      visitsMinors: state.visitsMinors,
      newAdults: state.newAdults,
      newMinors: state.newMinors
    });
  }

  /**
   * Resetea el formulario a valores iniciales
   */
  resetForm(form: FormGroup): void {
    form.reset({
      date: '',
      type: '',
      bibleText: '',
      memberInCharge: '',
      location: '',
      organizationUnitId: '',
      totalMinors: 0,
      totalAdults: 0,
      notes: '',
      offeringsARS: null,
      offeringsUSD: null,
      visitsAdults: 0,
      visitsMinors: 0,
      newAdults: 0,
      newMinors: 0
    });
  }

  /**
   * Habilita/deshabilita el formulario completamente
   */
  setFormEnabled(form: FormGroup, enabled: boolean): void {
    if (enabled) {
      form.enable();
    } else {
      form.disable();
    }
  }
}
